
import { ApiParameter, get, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface MYHProductDataModel {
    documents: Documents[],
    productTitle: string,
    content: Content,
    canonicalUrl: string,
    images: Images[],
    properties: Properties
}

export interface Properties {
    primaryImageId?: string
}
export interface Images {
    id: string,
    imageAltText: string,
    imageType: string,
    largeImagePath: string,
    mediumImagePath: string,
    name: string
    smallImagePath: string
    sortOrder: number
}
export interface Content {
    htmlContent: string
}
export interface Documents {
    id: string;
    name: string;
    filePath: string;
    documentType: string,
    description: string,
}

export interface MYHProductModel {
    finished_Item_Number: string;
    Purity_ID: string;
    cofc: Cofc;
    finished_batch_id: string;
    ingredients: { [key: string]: Ingredient };
    integrity_ExpirationDate: Date;
    lab_approval_date: Date;
    manufactured_date: Date;
    product_tests: any[];
    sellable_item: SellableItem;
    slug: string;
    tech_1_bio: string;
    tech_2_bio: string;
    tech_3_bio: string;
    verifications: string;
}

export interface Cofc {
    best_by: Date;
    concentration_equivalency: string;
    ingredients: string;
    ingredients_mineral: string;
    integrity_tests: IntegrityTests;
    latin_name: string;
    master_id: string;
    mfg_date: Date;
    other_ingredients: string;
    potency_tests: PotencyTest[];
    product_integrity_tests: ProductIntegrityTest[];
    purity_tests: PurityTests;
    solvents: string;
    verifications: string;
}

export interface IntegrityTests {
    [key: string]: IntegrityTest[];
}

export interface IntegrityTest {
    identity: string;
    result: string;
    specification: string;
}

export interface PotencyTest {
    bioactivity?: string;
    method: string;
    result: string;
    specification: string;
    name?: string;
}

export interface ProductIntegrityTest {
    category: string;
    id: string;
    id_test: string;
    id_test_request: string;
    method: string;
    name: string;
    product_lot: string;
    result: string;
    specification: string;
    type: string;
}

export interface PurityTests {
    "heavy Metals": PotencyTest[];
    microbial: PotencyTest[];
    pesticides: PotencyTest[];
}

export interface Ingredient {
    bioregion: null;
    certifications: any[];
    cms: CMS;
    farm_show_link: boolean;
    ingredient_gaia3digit: string;
    ingredient_item_num: null;
    ingredient_itemnumber: string;
    ingredient_lot_id: string;
    integrity_CountryOfOrigin: string;
    integrity_commonnames: string;
    integrity_harvesttype: string;
    integrity_identityvalidationmethod: any[];
    integrity_vendorclass: string;
    plant_part: string;
    seed_farm_name: string;
    seed_farm_type: string;
    tests: any[];
}

export interface CMS {
    id: number;
    name: string;
    slug: string;
    technical_name: string;
}

export type SellableItem = {
    [key: string]: SellableItemProps;
} & {
    product_id: string;
    slug: string;
};

export interface SellableItemProps {
    categories: string;
    concentration_equivalency: string;
    conditions: string;
    id: string;
    image_3: string;
    ingredients: string;
    ingredients_mineral: string;
    ingredients_other: string;
    ingredients_solvent: string;
    name: string;
    regimen: string;
    sub_name: string;
    verifications: string;
}

export interface GetMYHProductApiParameters extends ApiParameter {
    purityId: string;
}

type ProductModel = {
    herbsData: MYHProductModel; productData: any
}

const apiUrl = "/api/v2/myh";

export async function getMYHProduct(parameter: GetMYHProductApiParameters) {
    try {

        const productModel = await get<{ herbsData: MYHProductModel; productData: any }>("/api/v2/myh", parameter);
        return {
            result: productModel,
            successful: true,
        };

    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404 || error.status === 500) && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;

    }
    // return {
    //     Finished_Item_Number: "90A63060",
    //     Purity_ID: "A63060-55",
    //     cofc: {
    //         best_by: "2025-08-04",
    //         concentration_equivalency: "Standardized to 36 mg/serving of Total Curcuminoids",
    //         ingredients:
    //             "Black Pepper Fruit Supercritical Extract <em>(Piper nigrum)</em>, Turmeric Root <em>(Curcuma longa)</em>, Turmeric Root Extract <em>(Curcuma longa)</em>, Turmeric Root Supercritical Extract <em>(Curcuma longa)</em>",
    //         ingredients_mineral: "",
    //         integrity_tests: {
    //             "Black Pepper Fruit Supercritical Extract": [
    //                 {
    //                     identity: "Identity: Organoleptic - Color",
    //                     result: "match ",
    //                     specification: "Yellowish brown to light greenish yellow",
    //                 },
    //                 {
    //                     identity: "Identity: Organoleptic - Appearance",
    //                     result: "match ",
    //                     specification: "Semi-solid liquid extract",
    //                 },
    //                 {
    //                     identity: "Identity/Composition: Fingerprint",
    //                     result: "Pass",
    //                     specification: "Conforms to DNA Validated Reference Material",
    //                 },
    //             ],
    //             "Turmeric Root": [
    //                 {
    //                     identity: "Identity: Organoleptic - Color",
    //                     result: "match ",
    //                     specification: "Golden yellow or orange",
    //                 },
    //                 {
    //                     identity: "Identity: Organoleptic - Appearance",
    //                     result: "match ",
    //                     specification: "Whole pieces or slices of root; pale to light golden ",
    //                 },
    //                 {
    //                     identity: "Identity/Composition: Fingerprint",
    //                     result: "Pass",
    //                     specification: "Conforms to DNA Validated Reference Material",
    //                 },
    //                 {
    //                     identity: "Strength: NIR Fingerprint",
    //                     result: "Pass",
    //                     specification: "NLT 850 mg/g Curcuminoids",
    //                 },
    //                 {
    //                     identity: "Identity/Composition: Desmethoxycurcumin",
    //                     result: "present %",
    //                     specification: "Confirm presence",
    //                 },
    //                 {
    //                     identity: "Identity/Composition: Curcumin",
    //                     result: "Pass",
    //                     specification: "Confirm presence",
    //                 },
    //                 {
    //                     identity: "Identity/Composition:  Bisdesmethoxycurcumin",
    //                     result: "present %",
    //                     specification: "Confirm presence",
    //                 },
    //             ],
    //             "Turmeric Root Extract": [
    //                 {
    //                     identity: "Strength: NIR Fingerprint",
    //                     result: "Pass",
    //                     specification: "NLT 850 mg/g Curcuminoids",
    //                 },
    //                 {
    //                     identity: "Identity/Composition: Desmethoxycurcumin",
    //                     result: "present %",
    //                     specification: "Confirm presence",
    //                 },
    //                 {
    //                     identity: "Identity/Composition: Curcumin",
    //                     result: "Pass",
    //                     specification: "Confirm presence",
    //                 },
    //                 {
    //                     identity: "Identity/Composition:  Bisdesmethoxycurcumin",
    //                     result: "present %",
    //                     specification: "Confirm presence",
    //                 },
    //                 {
    //                     identity: "Identity: Organoleptic - Color",
    //                     result: "match ",
    //                     specification: "Golden yellow or orange",
    //                 },
    //                 {
    //                     identity: "Identity: Organoleptic - Appearance",
    //                     result: "match ",
    //                     specification: "Whole pieces or slices of root; pale to light golden ",
    //                 },
    //                 {
    //                     identity: "Identity/Composition: Fingerprint",
    //                     result: "Pass",
    //                     specification: "Conforms to DNA Validated Reference Material",
    //                 },
    //             ],
    //             "Turmeric Root Supercritical Extract": [
    //                 {
    //                     identity: "Strength: NIR Fingerprint",
    //                     result: "Pass",
    //                     specification: "NLT 850 mg/g Curcuminoids",
    //                 },
    //                 {
    //                     identity: "Identity/Composition: Desmethoxycurcumin",
    //                     result: "present ",
    //                     specification: "Confirm presence",
    //                 },
    //                 {
    //                     identity: "Identity/Composition: Curcumin",
    //                     result: "Pass",
    //                     specification: "Confirm presence",
    //                 },
    //                 {
    //                     identity: "Identity/Composition:  Bisdesmethoxycurcumin",
    //                     result: "present ",
    //                     specification: "Confirm presence",
    //                 },
    //                 {
    //                     identity: "Identity: Organoleptic - Color",
    //                     result: "match ",
    //                     specification: "Golden yellow or orange",
    //                 },
    //                 {
    //                     identity: "Identity: Organoleptic - Appearance",
    //                     result: "match ",
    //                     specification: "Whole pieces or slices of root; pale to light golden ",
    //                 },
    //                 {
    //                     identity: "Identity/Composition: Fingerprint",
    //                     result: "Pass",
    //                     specification: "Conforms to DNA Validated Reference Material",
    //                 },
    //             ],
    //         },
    //         latin_name: "See ingredients list.",
    //         master_id: "A63060-55",
    //         mfg_date: "2022-08-04",
    //         other_ingredients: "Capsule (vegetable cellulose),Water,Vegetable Glycerine,Lecithin",
    //         potency_tests: [
    //             {
    //                 bioactivity: "Strength: Total Curcuminoids ",
    //                 method: "HPLC",
    //                 result: "65 mg/serving",
    //                 specification: "43-86 mg/serving",
    //             },
    //         ],
    //         product_integrity_tests: [
    //             {
    //                 category: "Identity",
    //                 id: "85023",
    //                 id_test: "3",
    //                 id_test_request: "7998",
    //                 method: "UV/Vis or HPLC",
    //                 name: "UV/Vis or HPLC Fingerprint",
    //                 product_lot: "A63060-55",
    //                 result: "Pass",
    //                 specification: "Conforms",
    //                 type: "Integrity",
    //             },
    //         ],
    //         purity_tests: {
    //             "Heavy Metals": [
    //                 {
    //                     method: "ICP-MS",
    //                     name: "Purity: Lead (Pb)",
    //                     result: "Pass",
    //                     specification: "NMT 0.5 µg/day",
    //                 },
    //                 {
    //                     method: "ICP-MS",
    //                     name: "Purity: Mercury (Hg)",
    //                     result: "Pass",
    //                     specification: "NMT 0.3 µg/day",
    //                 },
    //                 {
    //                     method: "ICP-MS",
    //                     name: "Purity: Cadmium (Cd)",
    //                     result: "Pass",
    //                     specification: "NMT 4.1 µg/day",
    //                 },
    //                 {
    //                     method: "ICP-MS",
    //                     name: "Purity: Arsenic (As)",
    //                     result: "Pass",
    //                     specification: "NMT 10.0 µg/day",
    //                 },
    //             ],
    //             Microbial: [
    //                 {
    //                     method: "Bio Control 1-2",
    //                     name: "Purity: Salmonella",
    //                     result: "Pass",
    //                     specification: "absent in 10 g",
    //                 },
    //                 {
    //                     method: "Soleris/Plate",
    //                     name: "Purity: E. Coli",
    //                     result: "Pass",
    //                     specification: "absent in 10 g",
    //                 },
    //                 {
    //                     method: "Soleris/Plate",
    //                     name: "Purity: Yeast & Mold",
    //                     result: "Pass",
    //                     specification: "NMT 300 cfu/g",
    //                 },
    //                 {
    //                     method: "Soleris/Plate",
    //                     name: "Purity: A.P.",
    //                     result: "Pass",
    //                     specification: "NMT 25,000 cfu/g",
    //                 },
    //             ],
    //             Pesticides: [
    //                 {
    //                     method: "GC-MS-MS",
    //                     name: "Purity: Pesticides",
    //                     result: "Pass",
    //                     specification: "Below MRL",
    //                 },
    //             ],
    //         },
    //         solvents: "USP Alcohol (Only used during extraction and subsequently removed during concentration.),Water",
    //         verifications: "Non-GMO,No Toxic Solvents Used,Vegetarian,Gluten Free,Corn Free",
    //     },
    //     finished_batch_id: "112877",
    //     ingredients: {
    //         "81866": {
    //             bioregion: null,
    //             certifications: [],
    //             cms: {
    //                 id: 661,
    //                 name: "Black Pepper",
    //                 slug: "black-pepper",
    //                 technical_name: "Piper Nigrum",
    //             },
    //             farm_show_link: false,
    //             ingredient_gaia3digit: "BPE",
    //             ingredient_item_num: null,
    //             ingredient_itemnumber: "00BPE000",
    //             ingredient_lot_id: "81866",
    //             integrity_CountryOfOrigin: "INDIA",
    //             integrity_commonnames: "Black Pepper Fruit Supercritical Extract",
    //             integrity_harvesttype: "Ecologically Harvested",
    //             integrity_identityvalidationmethod: [],
    //             integrity_vendorclass: "Gaia Validated Partner",
    //             plant_part: "Fruit",
    //             seed_farm_name: "Gaia Validated Partner",
    //             seed_farm_type: "Proprietary Source",
    //             tests: [],
    //         },
    //         "82085": {
    //             bioregion: null,
    //             certifications: [],
    //             cms: {
    //                 id: 167,
    //                 name: "Turmeric",
    //                 slug: "turmeric",
    //                 technical_name: "Curcuma longa",
    //             },
    //             farm_show_link: false,
    //             ingredient_gaia3digit: "676",
    //             ingredient_item_num: null,
    //             ingredient_itemnumber: "00676000",
    //             ingredient_lot_id: "82085",
    //             integrity_CountryOfOrigin: "NICARAGUA",
    //             integrity_commonnames: "Turmeric Root",
    //             integrity_harvesttype: "Certified Organic",
    //             integrity_identityvalidationmethod: [],
    //             integrity_vendorclass: "Certified Organic Farm",
    //             plant_part: "Root",
    //             seed_farm_name: "Gaia Validated Partner",
    //             seed_farm_type: "Proprietary Source",
    //             tests: [],
    //         },
    //         "82417": {
    //             bioregion: null,
    //             certifications: [],
    //             cms: {
    //                 id: 661,
    //                 name: "Black Pepper",
    //                 slug: "black-pepper",
    //                 technical_name: "Piper Nigrum",
    //             },
    //             farm_show_link: false,
    //             ingredient_gaia3digit: "BPE",
    //             ingredient_item_num: null,
    //             ingredient_itemnumber: "00BPE000",
    //             ingredient_lot_id: "82417",
    //             integrity_CountryOfOrigin: "INDIA",
    //             integrity_commonnames: "Black Pepper Fruit Supercritical Extract",
    //             integrity_harvesttype: "Ecologically Harvested",
    //             integrity_identityvalidationmethod: [],
    //             integrity_vendorclass: "Gaia Validated Partner",
    //             plant_part: "Fruit",
    //             seed_farm_name: "Gaia Validated Partner",
    //             seed_farm_type: "Proprietary Source",
    //             tests: [],
    //         },
    //         "83650": {
    //             bioregion: null,
    //             certifications: [],
    //             cms: {
    //                 id: 167,
    //                 name: "Turmeric",
    //                 slug: "turmeric",
    //                 technical_name: "Curcuma longa",
    //             },
    //             farm_show_link: false,
    //             ingredient_gaia3digit: "676",
    //             ingredient_item_num: null,
    //             ingredient_itemnumber: "00676000",
    //             ingredient_lot_id: "83650",
    //             integrity_CountryOfOrigin: "NICARAGUA",
    //             integrity_commonnames: "Turmeric Root",
    //             integrity_harvesttype: "Certified Organic",
    //             integrity_identityvalidationmethod: [],
    //             integrity_vendorclass: "Certified Organic Farm",
    //             plant_part: "Root",
    //             seed_farm_name: "Gaia Validated Partner",
    //             seed_farm_type: "Proprietary Source",
    //             tests: [],
    //         },
    //         "83945": {
    //             bioregion: null,
    //             certifications: [],
    //             cms: {
    //                 id: 708,
    //                 name: "Turmeric",
    //                 slug: "turmeric",
    //                 technical_name: "",
    //             },
    //             farm_show_link: false,
    //             ingredient_gaia3digit: "CRC",
    //             ingredient_item_num: null,
    //             ingredient_itemnumber: "00CRC000",
    //             ingredient_lot_id: "83945",
    //             integrity_CountryOfOrigin: "INDIA",
    //             integrity_commonnames: "Turmeric Root Extract",
    //             integrity_harvesttype: "Ecologically Harvested",
    //             integrity_identityvalidationmethod: [],
    //             integrity_vendorclass: "Gaia Validated Partner",
    //             plant_part: "Root",
    //             seed_farm_name: "Gaia Validated Partner",
    //             seed_farm_type: "Proprietary Source",
    //             tests: [],
    //         },
    //         "83946": {
    //             bioregion: null,
    //             certifications: [],
    //             cms: {
    //                 id: 708,
    //                 name: "Turmeric",
    //                 slug: "turmeric",
    //                 technical_name: "",
    //             },
    //             farm_show_link: false,
    //             ingredient_gaia3digit: "CRC",
    //             ingredient_item_num: null,
    //             ingredient_itemnumber: "00CRC000",
    //             ingredient_lot_id: "83946",
    //             integrity_CountryOfOrigin: "INDIA",
    //             integrity_commonnames: "Turmeric Root Extract",
    //             integrity_harvesttype: "Ecologically Harvested",
    //             integrity_identityvalidationmethod: [],
    //             integrity_vendorclass: "Gaia Validated Partner",
    //             plant_part: "Root",
    //             seed_farm_name: "Gaia Validated Partner",
    //             seed_farm_type: "Proprietary Source",
    //             tests: [],
    //         },
    //         "84629": {
    //             bioregion: null,
    //             certifications: [],
    //             cms: {
    //                 id: 606,
    //                 name: "Tumeric Root Supercritical Extract",
    //                 slug: "turmeric",
    //                 technical_name: "Curcuma longa",
    //             },
    //             farm_show_link: false,
    //             ingredient_gaia3digit: "CUR",
    //             ingredient_item_num: null,
    //             ingredient_itemnumber: "00CUR000",
    //             ingredient_lot_id: "84629",
    //             integrity_CountryOfOrigin: "INDIA",
    //             integrity_commonnames: "Turmeric Root Supercritical Extract",
    //             integrity_harvesttype: "Ecologically Harvested",
    //             integrity_identityvalidationmethod: [],
    //             integrity_vendorclass: "Gaia Validated Partner",
    //             plant_part: "Root",
    //             seed_farm_name: "Gaia Validated Partner",
    //             seed_farm_type: "Proprietary Source",
    //             tests: [],
    //         },
    //     },
    //     integrity_ExpirationDate: "2025-08-04",
    //     lab_approval_date: "2022-08-10",
    //     manufactured_date: "2022-08-04",
    //     product_tests: [],
    //     sellable_item: {
    //         "0": {
    //             categories: "62",
    //             concentration_equivalency: "Standardized to 36 mg/serving of Total Curcuminoids",
    //             conditions: "7,12,8,21,45,28,47",
    //             id: "83",
    //             image_3: "TurmericSupremeExtraStrength_LAA63060_013-998-0418_SUPP1-1535479865.jpg",
    //             ingredients: "661,605,167",
    //             ingredients_mineral: "",
    //             ingredients_other: "Capsule (vegetable cellulose),Water,Vegetable Glycerine,Lecithin",
    //             ingredients_solvent:
    //                 "USP Alcohol (Only used during extraction and subsequently removed during concentration.),Water",
    //             name: "Turmeric Supreme® Extra Strength",
    //             regimen: "15,14,8",
    //             sub_name: "Supports a healthy inflammatory response*",
    //             verifications: "Non-GMO,No Toxic Solvents Used,Vegetarian,Gluten Free,Corn Free",
    //         },
    //         product_id: "83",
    //         slug: "turmeric-supreme-extra-strength",
    //     },
    //     slug: "turmeric-supreme-extra-strength",
    //     tech_1_bio: "",
    //     tech_2_bio: "",
    //     tech_3_bio: "",
    //     verifications: "",
    // } as unknown as MYHProductModel;
}
